import { configureStore } from "@reduxjs/toolkit";
import UserReducer from "../features/userReducer.js";
import StatusReducer from "../features/statusReducer.js";

export const store = configureStore({
    reducer: {
        user: UserReducer,
        status: StatusReducer,
    }
});
